import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkComponent } from '../../../link/link.component';

@Component({
    selector: 'nw-media-enquiries-block',
    imports: [LinkComponent],
    templateUrl: './media-enquiries-block.component.html',
    styleUrl: './media-enquiries-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaEnquiriesBlockComponent {
    @Input() name!: string;
    @Input() telephone!: string;
    @Input() email!: string;
}
